import { render } from "./won-prize.vue?vue&type=template&id=4cb1d63d&scoped=true"
import script from "./won-prize.vue?vue&type=script&lang=js"
export * from "./won-prize.vue?vue&type=script&lang=js"

import "./won-prize.vue?vue&type=style&index=0&id=4cb1d63d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb1d63d"]])

export default __exports__